module.exports = __webpack_public_path__ + "img/icon-warning-rain-yellow.dfb80b96.svg";